export class SaleOrderStatusDropdownDto{
    saleOrderStatus:string;
    
      constructor(saleOrderStatus:string){
        this.saleOrderStatus = saleOrderStatus;
      }
  }